<template>
  <v-card flat>
    <v-card-title class="card-bg-2" :id="`step-${index}`">
      <div class="headline pb-0" :class="{ 'grey--text': disabled }" style="align-items: baseline; display: flex;">
        Analytes
        <v-menu v-model="showHelp" offset-y open-on-hover :open-delay="400">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" @click="showHelp = true" class="clickable ml-2" color="primary">
              info_outline
            </v-icon>
          </template>
          <v-card>
            <v-card-text> The analytes shown is the union of analytes from all selected stations within the selected date range.
            </v-card-text>
          </v-card>
        </v-menu>
      </div>
      <v-spacer />
      <v-text-field :disabled="disabled" prepend-inner-icon="search" v-model="search" class="rounded font-weight-regular emphasize-clear" hide-details clearable @click:clear="clearSearch()" solo @keyup.enter="toggleCurrentAnalytes()" placeholder="Search analytes">
      </v-text-field>
    </v-card-title>
    <ShowAnalytes ref="showAnalytes" @analytes="selectedAnalytes = $event" :allAnalytes="allAnalytes" :analytes="analytes" :selection="selection" :search="search" :disabled="disabled" />
  </v-card>
</template>

<script>
  import ShowAnalytes from './ShowAnalytes'

  export default {
    components: {
      ShowAnalytes,
    },
    props: {
      allAnalytes: Array,
      analytes: Object,
      selection: Object,
      index: Number,
      disabled: Boolean,
    },
    data() {
      return {
        showHelp: false,
        search: '',
        selectedAnalytes: [],
      }
    },
    watch: {
      selectedAnalytes(value) {
        this.$emit('analytes', value)
      },
    },
    methods: {
      clearSearch() {
        this.$nextTick(() => this.search = '')
      },
      toggleCurrentAnalytes() {
        this.$refs.showAnalytes.toggleCurrentAnalytes()
      },
      selectAnalyteNames(analyteNames) {
        this.clearSearch()
        this.$refs.showAnalytes.selectAnalyteNames(analyteNames)
      },
    },
  }
</script>